export default __webpack_public_path__ + "static/media/m-bottom-img-service-in-the-office.29369486.png";